import {
  ALLOW_DISALLOW_COUNTRY_SUCCESS,
  ALLOW_DISALLOW_COUNTRY_FAILED,
  RESET_ALLOW_DISALLOW_COUNTRY,
  LOADING_RALLOW_DISALLOW_COUNTRY,
  NETWORK_ERROR_ALLOW_DISALLOW_COUNTRY,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_RALLOW_DISALLOW_COUNTRY:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case ALLOW_DISALLOW_COUNTRY_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case ALLOW_DISALLOW_COUNTRY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_ALLOW_DISALLOW_COUNTRY:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_ALLOW_DISALLOW_COUNTRY:
      return (state = initialState);
    default:
      return state;
  }
};
